export default __webpack_public_path__ + "static/1835-0afaef69bb56e54233733be37c4aadac.gif";